import React from "react";
var __jsx = React.createElement;
import { CDN_LINK } from "@globalConfig";
import stl from "./ContactAgentComponent.module.css";
import { useTranslation } from "@i18n";
import useWebView from "@hooks/useWebview";
var ContactAgent = function ContactAgent(_ref) {
  var _details$sales_person, _details$sales_person2, _details$sales_person3, _details$sales_person4;
  var details = _ref.details,
    className = _ref.className,
    customMarginTop = _ref.customMarginTop;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var webview = useWebView();
  var openUri = function openUri(link) {
    return function (e) {
      e.preventDefault();
      webview.openUri(link)["catch"](function () {
        window.location.href = link;
      });
    };
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.mandoobInfo, " ").concat(className ? className : "", " ").concat(customMarginTop ? customMarginTop : "")
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, t("sales_agent", {
    ns: "web_tracking_finance"
  })), /*#__PURE__*/React.createElement("strong", null, details === null || details === void 0 ? void 0 : (_details$sales_person = details.sales_person) === null || _details$sales_person === void 0 ? void 0 : _details$sales_person.name)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
    id: "order-agent-call-btn",
    className: stl.call,
    href: "#",
    onClick: openUri("tel:" + (details === null || details === void 0 ? void 0 : (_details$sales_person2 = details.sales_person) === null || _details$sales_person2 === void 0 ? void 0 : _details$sales_person2.phone_number))
  }, /*#__PURE__*/React.createElement("img", {
    width: "18px",
    src: CDN_LINK + "/assets/images/CallTM.svg",
    alt: "call"
  }), /*#__PURE__*/React.createElement("div", {
    className: ["m-hide", stl.DTCallInfo].join(" ")
  }, /*#__PURE__*/React.createElement("p", null, t("sales_representative_s_phone_number", {
    ns: "web_tracking_finance"
  })), /*#__PURE__*/React.createElement("strong", null, details === null || details === void 0 ? void 0 : (_details$sales_person3 = details.sales_person) === null || _details$sales_person3 === void 0 ? void 0 : _details$sales_person3.phone_number))), /*#__PURE__*/React.createElement("a", {
    id: "order-agent-whatsapp-btn",
    className: stl.wts,
    href: "#",
    onClick: openUri("https://wa.me/+966" + (details === null || details === void 0 ? void 0 : (_details$sales_person4 = details.sales_person) === null || _details$sales_person4 === void 0 ? void 0 : _details$sales_person4.phone_number))
  }, /*#__PURE__*/React.createElement("img", {
    width: "20px",
    src: CDN_LINK + "/assets/images/whTM.svg",
    alt: "call"
  })))));
};
export default ContactAgent;